const mapStateToProps = (state) => {
    const {
        service:{
            Geozone:{
                addVertex,
            }={}
        }={},
    }=state;
    return {
        addVertex,
    }
}

export default mapStateToProps;